<template>
	<div>
		<p class="app-font-size-18 app-font-color-grey">
			<font class="app-font-size-24 app-font-color-red">发布作品</font>
			/ 收益明细
		</p>
		<div class="app-table-center app-bg-color-grey-dark app-border-radius-8 app-padding-20">
			<el-table :data="recordList" class="head-border">
				<el-table-column prop="title" label="名称"></el-table-column>
				<el-table-column prop="cover" label="图例">
					<template  slot-scope="scope">
						<img width="80" height="60" :src="scope.row.cover" />
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="发布时间" width="290"></el-table-column>
				<el-table-column prop="price" label="价格(金币)"></el-table-column>
				<el-table-column prop="salesNum" label="被购买数">
					<template  slot-scope="scope">
						<div v-text="scope.row.salesNum == -1 ? 0 : scope.row.salesNum"></div>
					</template>
				</el-table-column>
				<el-table-column prop="getDiamondNum" label="钻石收益">
					<template slot-scope="scope">
						<div v-text="scope.row.getDiamondNum == -1 ? 0 : scope.row.getDiamondNum"></div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="app-pagination-container">
			<el-pagination
				v-if="pagination.total > 0"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pagination.currentPage"
				:page-sizes="pagination.pageSizeArray"
				layout=" prev, pager, next, sizes, jumper"
				:page-size="pagination.pageSize"
				:page-count="pagination.pageCount"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import service from '../../../service/model';
import noData from '../../../components/noData.vue';
import { mapState } from 'vuex';
export default {
	inject: ['reload'],
	components: {
		noData
	},
	data() {
		return {
			pagination: {
				pageCount: 1,
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageSizeArray: [10, 20, 30, 50]
			},
			recordList: []
		};
	},
	computed: {
		...mapState({
			userInfo: state => state.userInfo.data
		})
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 明细
		getList() {
			service.getUserPublistModel(this.userInfo.id, '','', this.pagination.pageSize, this.pagination.currentPage, res => {
				this.recordList = res.data.records || [];
				this.pagination.total = res.data.total;
				this.pagination.pageCount = res.data.pages;
			});
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.pagination.currentPage = val;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
